import React from 'react';
import { Paper, Grid, Box, List, Typography } from '@material-ui/core';

import LocationInfoListItem from './components/LocationInfoListItem';
import ContactInfoListItem from './components/ContactInfoListItem';
import HoursInfoListItem from './components/HoursInfoListItem';

import useStyles from './styles';
import useBooking from '../../../../context/useBooking';
import { useTranslations } from 'components/utilities';

const BookingDetailsOffice = ({ boxPaddings }) => {
	const classes = useStyles();
	const { t } = useTranslations();

	const { booking } = useBooking();

	return (
		<Paper>
			<Box {...boxPaddings}>
				<Grid container spacing={1} justify="space-between" wrap="nowrap">
					<Grid item xs="auto">
						<Typography variant="h5" color="primary">
							{t('booking.rentalOffice')}
						</Typography>
					</Grid>
					<Grid item xs="auto">
						<img
							src={booking.car.office.logo}
							alt="Office"
							className={classes.officeImage}
						/>
					</Grid>
				</Grid>

				<List>
					<LocationInfoListItem />

					<ContactInfoListItem />

					<HoursInfoListItem />
				</List>
			</Box>
		</Paper>
	);
};

export default BookingDetailsOffice;
